"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrencyPostSeparator = exports.getCurrencyPreSeparator = exports.getCurrencySeparator = exports.getCurrencySymbol = exports.formatCurrency = exports.convertCurrencyBaseUnit = void 0;
const locale_1 = require("./locale");
const getCurrency = (brand) => {
    switch (brand) {
        case 'PILOT':
        case 'KIN':
        case 'SOFTWARE':
        case 'JUNIPER':
            return 'AUD';
        case 'COMPOUND_UK':
        case 'JUNIPER_UK':
            return 'GBP';
        case 'JUNIPER_DE':
            return 'EUR';
        case 'JUNIPER_JP':
            return 'JPY';
        default:
            throw new Error(`unsupport brand for currency ${brand}`);
    }
};
/**
 * Converts an amount in base units to a standard unit representation.
 *
 * For example, in Australia 1000 will be represented as 10 (cents -> dollars),
 * but in Japan 1000 will be 1000 (yen -> yen).
 */
const convertCurrencyBaseUnit = (brand, amountInBaseUnit) => {
    const currency = getCurrency(brand);
    let baseUnitMultiple;
    switch (currency) {
        case 'AUD':
        case 'EUR':
        case 'GBP':
            baseUnitMultiple = 0.01;
            break;
        case 'JPY':
            baseUnitMultiple = 1;
            break;
        default:
            throw new Error(`unsupport currency for multiple ${currency}`);
    }
    return amountInBaseUnit * baseUnitMultiple;
};
exports.convertCurrencyBaseUnit = convertCurrencyBaseUnit;
const formatCurrency = (brand, amountInBaseUnit, options) => {
    const locale = (0, locale_1.getCurrencyLocale)(brand);
    const currency = getCurrency(brand);
    const amount = (0, exports.convertCurrencyBaseUnit)(brand, amountInBaseUnit);
    let formatOptions = {
        signDisplay: options.signDisplay,
        style: 'currency',
        currency,
    };
    if (!options.includeDecimals ||
        (options.omitZeroDecimals && amount % 1 === 0)) {
        formatOptions = {
            ...formatOptions,
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
        };
    }
    const formatter = new Intl.NumberFormat(locale, formatOptions);
    if (options.includeSymbol) {
        return formatter.format(amount);
    }
    return formatter
        .formatToParts(amount)
        .filter((p) => p.type !== 'currency')
        .map((p) => p.value)
        .join('')
        .trim();
};
exports.formatCurrency = formatCurrency;
function getCurrencySymbol(brand) {
    switch (brand) {
        case 'PILOT':
        case 'KIN':
        case 'SOFTWARE':
        case 'JUNIPER':
            return '$';
        case 'COMPOUND_UK':
        case 'JUNIPER_UK':
            return '£';
        case 'JUNIPER_DE':
            return '€';
        case 'JUNIPER_JP':
            return '¥';
        default:
            throw new Error(`unsupport brand for currency ${brand}`);
    }
}
exports.getCurrencySymbol = getCurrencySymbol;
function getCurrencySeparator(brand) {
    switch (brand) {
        case 'PILOT':
        case 'KIN':
        case 'SOFTWARE':
        case 'JUNIPER':
        case 'JUNIPER_UK':
        case 'COMPOUND_UK':
            return '.';
        case 'JUNIPER_DE':
            return ',';
        case 'JUNIPER_JP':
            // TODO (ENG-860) consider splitting at the millions
            return '';
        default:
            throw new Error(`unsupport brand for currency ${brand}`);
    }
}
exports.getCurrencySeparator = getCurrencySeparator;
function getCurrencyPreSeparator(amount, brand) {
    if (brand === 'JUNIPER_JP') {
        // TODO (ENG-860) thousands separators (',' or maybe ' ')
        return amount.toString();
    }
    // TODO (ENG-860) thousands separators (brand===juni_de ?  '.' : ',')
    return ((amount - (amount % 100)) / 100).toFixed(0);
}
exports.getCurrencyPreSeparator = getCurrencyPreSeparator;
function getCurrencyPostSeparator(amount, brand) {
    if (brand === 'JUNIPER_JP') {
        return '';
    }
    const postSep = amount % 100;
    if (postSep < 10) {
        return `0${postSep}`;
    }
    return postSep.toFixed(0);
}
exports.getCurrencyPostSeparator = getCurrencyPostSeparator;
